// extracted by mini-css-extract-plugin
export default {"title":"Title_title__co84a","leftStroke":"Title_leftStroke__oCFPF","bottomStroke":"Title_bottomStroke__0kPp5"};